import {WandSparkles} from "lucide-react";
import DetailPaneState from "@/components/management/DetailPaneState.tsx";

export default function SpellEmpty() {
    return (
        <>
            <title>Zauber | DireDawn</title>
            <DetailPaneState title="Kein Zauber ausgewählt"
                             description="Wähle links einen Zauber aus oder erstelle einen neuen."
                             icon={<WandSparkles className="size-10 opacity-50"/>}/>
        </>
    );
}
